<template>
    <ul
        :class="[
          'flex flex-wrap mt-2',
          // 'md:justify-center',
        ]"
      >
        <!--source icons: https://www.flaticon.com/packs/allergenic-food-color?word=allergy-->
        <li
        v-for="(allergen, index) in activeAllergens" :key="index">
          <div 
          class="flex flex-col items-center mx-1"
          v-if="item[allergen.name]">
            <img
              class="rounded-full h-6 w-6 flex items-center justify-center border p-1"
              :alt="allergen.name"
              :src="
                require('../assets/images/allergenes/' + allergen.image)
              "
            />

            <p :class="['justify-center flex text-2xs']">
              {{ lang[allergen.languageKey][language] }}
            </p>
          </div>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import lang from '../lang'

export default {
    data() {
        return {
            lang,
            // allergens is used as a base to filter out the correct allergen per item
            // the item info usually comes from the api call - GetAllMenuItems[MenuItems]
            // if new allergens are added, please add them to list below.
            allergens: [
              {
                name: "hasGluten",
                image: "gluten.svg",
                languageKey: "gluten"
              },
              {
                name: "hasEgg",
                image: "egg.svg",
                languageKey: "egg"
              },
              {
                name: "hasFish",
                image: "fish.svg",
                languageKey: "fish"
              },
              {
                name: "hasLactose",
                image: "lactose.svg",
                languageKey: "milk"
              },
              {
                name: "hasMeat",
                image: "meat.svg",
                languageKey: "meat"
              },
              {
                name: "hasNuts",
                image: "nuts.svg",
                languageKey: "nuts"
              },
              {
                name: "hasPeanuts",
                image: "peanut.svg",
                languageKey: "peanut"
              },
              {
                name: "hasSoya",
                image: "soy.svg",
                languageKey: "soy"
              },
              {
                name: "isSugarFree",
                image: "sugarfree.svg",
                languageKey: "sugar_free"
              },
              {
                name: "isVegan",
                image: "vegan.svg",
                languageKey: "vegan"
              },
              {
                name: "isVegetarian",
                image: "vegetarian.svg",
                languageKey: "vegetarian"
              },
              {
                name: "hasMustard",
                image: "mustard.svg",
                languageKey: "mustard"
              },
              {
                name: "hasMolluscs",
                image: "mollusc.svg",
                languageKey: "mollusc"
              },
              {
                name: "hasCrustaceans",
                image: "crustacean.svg",
                languageKey: "crustaceans"
              },
              {
                name: "hasLupin",
                image: "lupin.svg",
                languageKey: "lupin"
              },
              {
                name: "hasCelery",
                image: "celery.svg",
                languageKey: "celery"
              },
              {
                name: "hasSesame",
                image: "sesame.svg",
                languageKey: "sesame"
              },
              {
                name: "hasSulphites",
                image: "sulphite.svg",
                languageKey: "sulphites"
              },
            ]
        }
    },
    computed: {
      ...mapGetters(["language", "menuSubCategories"]),
      activeAllergens() {
        return this.allergens.filter(el => this.item[el.name]);
        }
    },
    props: {
        item: Object,
        hasImage: Boolean
    }
}
</script>

<style>

</style>
